import http from '../apis/http';
import cookie from '../utils/cookie';

import {
    FETCH_LOGIN,
    SET_LOGIN_INFO,
    SET_COUPON_SELECTED,
    CHANGE_COUPON_SELECTED,
    SET_PAY_GLOBAL,
    CHANGE_PAY_GLOBAL,
    FETCH_UP_RELATION,
    CHANGE_UP_RELATION,
    TRIGGER_FOLLOW,
    UPDATE_FOLLOW_STATUS,
    SET_UP_RELATION,
    SET_FOLLOW_STAT,
    SET_FOLLOW_STATUS
} from './types';

export default {
    [FETCH_LOGIN]({commit}, { reload = false }) {
        if (window.__BILI_USER_INFO__ && !reload) {
            return commit(SET_LOGIN_INFO, window.__BILI_USER_INFO__);
        }
        return http({
            method: 'GET',
            url: 'x/web-interface/nav',
            params: {
                ts: new Date().getTime()
            },
            include: true
        }).then(res => {
            let loginInfo = {};
            if (res.status === 200 && res.data) {
                loginInfo = res.data.data || {};
                if (!window.__BILI_USER_INFO__) {
                    window.__BILI_USER_INFO__ = loginInfo;
                }
            }
            commit(SET_LOGIN_INFO, loginInfo);
        });
    },
    [CHANGE_COUPON_SELECTED]({commit}, payload) {
        commit(SET_COUPON_SELECTED, payload.couponSelected);
    },
    [CHANGE_PAY_GLOBAL]({commit}, payload) {
        commit(SET_PAY_GLOBAL, payload.pay);
    },
    [FETCH_UP_RELATION]({commit}, payload) {
        return http({
            method: 'GET',
            url: 'x/relation',
            params: {
                fid: payload.mid
            },
            include: true
        }).then(res => {
            if (res.status === 200 && res.data && res.data.code === 0) {
                let result = res.data.data || {};
                commit(SET_UP_RELATION, result);
            } else {
                commit(SET_UP_RELATION, {});
            }
        });
    },
    [CHANGE_UP_RELATION]({commit}, payload) {
        commit(SET_UP_RELATION, {
            followed: payload.followed,
            attribute: payload.attr
        });
    },
    [TRIGGER_FOLLOW]({commit}, payload) {
        let type = payload.follow ? 'add' : 'del';
        let params = {
            season_id: payload.ssId,
            csrf: cookie.get('bili_jct') || ''
        };
        return http({
            method: 'POST',
            url: `pgc/web/follow/${type}`,
            params,
            include: true
        }).then(res => {
            if (res.status === 200 && res.data && res.data.code === 0) {
                commit(SET_FOLLOW_STAT, {
                    followed: payload.follow,
                    status: res.data.result ? res.data.result.status : undefined
                });
            } else {
                payload.errCb && payload.errCb();
                window.__Iris__ && window.__Iris__.report({
                    command: 'ogv.season.follow.fail',
                    status_code: res.data ? res.data.code : res.status,
                    extended_fields: {
                        request: params,
                        response: res,
                        cookie: document.cookie
                    }
                });
            }
        }).catch((err) => {
            payload.errCb && payload.errCb();
            window.__Iris__ && window.__Iris__.report({
                command: 'ogv.season.follow.error',
                extended_fields: {
                    request: params,
                    err: err ? (err.stack + err.message) : '',
                    cookie: document.cookie
                }
            });
        });
    },
    [UPDATE_FOLLOW_STATUS]({ commit }, payload) {
        commit(SET_FOLLOW_STATUS, payload.status);
    }
};